import React from 'react';

import { useTranslation } from 'react-i18next';

import { BaseResultItem } from './base-result-item/BaseResultItem';
import { FaceQualityChecksTable } from './face-quality-checks';
import type { FaceQualityChecksTableProps } from './face-quality-checks/FaceQualityChecksTable';
import { useTogglableTable } from './useTogglableTable';
import { CheckTag } from '../../check-tag/CheckTag';
import type { TResultStatus } from '../../check-tag/CheckTag';

interface FaceQualityResultItemProps extends FaceQualityChecksTableProps {
  status: TResultStatus;
}

function FaceQualityResultItem({
  checks,
  status,
}: FaceQualityResultItemProps): React.JSX.Element {
  const { t } = useTranslation();

  const failedCount = checks.filter(({ result }) => result === 0).length;

  const togglableTable = useTogglableTable({
    table: <FaceQualityChecksTable checks={checks} />,
  });

  return (
    <BaseResultItem
      label={t('checks:estimations.face_quality.title')}
      tag={(
        <CheckTag
          kind={status}
          toggle={togglableTable.toggle}
          value={status === 1
            ? t('checks:estimations.common.ok') as unknown as string
            : t('checks:estimations.common.error', { count: failedCount }) as unknown as string}
        />
      )}
    >
      {togglableTable.table}
    </BaseResultItem>
  );
}

export { FaceQualityResultItem };
